import { minPatchEditPermissionsDto } from '@arc/shared/util-data';
import { makeRecord, objectKeys } from '@arc/shared/util-js';
import { minPatchObject, minPatchPrimitive } from '@arc/shared/util-superstruct';
import { EditRoleDto } from './edit-role.dto';
export const minPatchEditRoleDto = minPatchObject({
  ...makeRecord(objectKeys(EditRoleDto.schema), () => minPatchPrimitive),
  permissions: minPatchEditPermissionsDto
});